import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';

import Input from 'common/components/form/inputs/Input';

import NumberInput from '@/library/components/form/inputs/NumberInput';
import Information from '@/library/components/general/Information';
import Select from '@/library/components/form/inputs/select/index';

const Airline = ({ formState }) => {
  const { fields, changeField, selectField } = useFormState(formState);

  return (
    <div>
      <Row className="g-0">
        <Col>
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>
      </Row>
      <Row className="g-2">
        <Col xs={6}>
          <Input
            maxLength={2}
            label={
              <>
                IATA DESIGNATOR
                <Information
                  message="2-Character-Code"
                  svgStyle={{
                    width: 12,
                    height: 12
                  }}
                  className="ms-1"
                />
              </>
            }
            onChange={changeField('iata_designator')}
            {...fields.iata_designator}
          />
        </Col>
        <Col xs={6}>
          <Input
            maxLength={3}
            label={
              <>
                ICAO DESIGNATOR
                <Information
                  message="3-Letter-Code"
                  svgStyle={{
                    width: 12,
                    height: 12
                  }}
                  className="ms-1"
                />
              </>
            }
            onChange={changeField('icao_code')}
            {...fields.icao_code}
          />
        </Col>
      </Row>
      <Row className="g-2 align-content-center">
        <Col xs={6}>
          <NumberInput
            label={
              <>
                IATA AIRLINE ACCOUNTING NUMBER
                <Information
                  message="3-Digit-Code"
                  svgStyle={{
                    width: 12,
                    height: 12
                  }}
                  className="ms-1"
                />
              </>
            }
            onChange={changeField('3_digit_code')}
            maxLength={3}
            {...fields['3_digit_code']}
          />
        </Col>
        <Col xs={6} className="">
          <Select
            memoizedRequestParams={{
              path: 'lists',
              params: { list: 'countries' }
            }}
            isAsync
            placeholder="Select country"
            isMulti={false}
            label="COUNTRY"
            isClearable={true}
            autoFocus={false}
            getOptionValue={option => option.id}
            getOptionLabel={option => option.name}
            onChange={option => selectField('country')(option)}
            {...fields.country}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Airline;
